class EditorialCardQuickAdd {
  constructor() {
    document.addEventListener('click', (event) => {
      const sizeButton = event.target.closest('[data-editorial-variant-id]');
      if (!sizeButton) return;

      const controls = sizeButton.closest('[data-editorial-card-controls]');
      if (!controls) return;

      controls.querySelectorAll('[data-editorial-variant-id]').forEach((button) => {
        button.classList.toggle('is-selected', button === sizeButton);
        button.setAttribute('aria-pressed', button === sizeButton ? 'true' : 'false');
      });

      const variantInput = controls.querySelector('input[name="id"]');
      if (variantInput) variantInput.value = sizeButton.dataset.editorialVariantId;
    });
  }
}

new EditorialCardQuickAdd();
